import { FC, useState } from 'react';

import {
	AiFoundPriceItem,
	formatFoundPrice,
} from '../../../utils/aiResults';
import { useAiReportContext } from '../../table/userSingleReport/aiReportContext';

import styles from './foundPricesCell.module.scss';

const PREVIEW_COUNT = 2;

interface IFoundPricesCellProps {
	items: AiFoundPriceItem[];
}

const FoundPricesCell: FC<IFoundPricesCellProps> = ({ items }) => {
	const { onPhotoIndexClick } = useAiReportContext();
	const [expanded, setExpanded] = useState(false);

	if (!items.length) {
		return null;
	}

	const visible = expanded ? items : items.slice(0, PREVIEW_COUNT);
	const hiddenCount = items.length - visible.length;

	return (
		<div className={styles.list}>
			{hiddenCount > 0 && !expanded && (
				<button
					type='button'
					className={styles.more}
					onClick={() => setExpanded(true)}
				>
					ещё {hiddenCount}
				</button>
			)}
			{visible.map((item, index) => (
				<div
					className={styles.row}
					key={`${item.mediaId || item.photoIndex}-${item.price}-${index}`}
				>
					{formatFoundPrice(item.price)} Р
					{item.photoLabel > 0 && (
						<>
							{' - '}
							<button
								type='button'
								className={styles.photoLink}
								onClick={() =>
									onPhotoIndexClick?.(
										item.photoIndex >= 0 ? item.photoIndex : item.photoLabel - 1
									)
								}
							>
								фото {item.photoLabel}
							</button>
						</>
					)}
				</div>
			))}
			{expanded && items.length > PREVIEW_COUNT && (
				<button
					type='button'
					className={styles.more}
					onClick={() => setExpanded(false)}
				>
					свернуть
				</button>
			)}
		</div>
	);
};

export default FoundPricesCell;
